import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-input-text-laudo',
  templateUrl: './input-text-laudo.component.html',
  styleUrls: ['./input-text-laudo.component.scss']
})
export class InputTextLaudoComponent implements OnInit {

  @Input() control = new FormControl('', [Validators.required]);
  @Input() label = "Desc. Input";
  @Input() required = true;
  @Input() mask = {mask: false, guide: false};

  @Output() focusIn = new EventEmitter();
  @Output() focusOut = new EventEmitter();

  constructor() {}

  ngOnInit() {}

}
